var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2042 6.3244C19.5887 5.93494 19.5887 5.30877 19.2042 4.91931L19.0083 4.72085C18.6167 4.32424 17.9765 4.32425 17.585 4.72085L12.0511 10.3264L6.31273 4.69797C5.91935 4.31212 5.28798 4.31721 4.90086 4.70933L4.70483 4.9079C4.31593 5.30183 4.32105 5.93675 4.71623 6.32436L10.45 11.9482L4.79581 17.6756C4.41133 18.0651 4.41133 18.6912 4.79581 19.0807L4.99173 19.2792C5.38327 19.6758 6.02347 19.6758 6.41501 19.2792L12.0511 13.5701L17.6872 19.2791C18.0788 19.6758 18.719 19.6758 19.1105 19.2792L19.3064 19.0807C19.6909 18.6912 19.6909 18.0651 19.3064 17.6756L13.6523 11.9482L19.2042 6.3244Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.9550f5f4cb4de01bc7065326e1fb4bfc.svg";
export { ForwardRef as ReactComponent };